import { Component, inject, OnInit, signal } from '@angular/core';

import '@diekeure/dcr-components/dcr-avatar.js';
import '@diekeure/dcr-components/dcr-checkbox.js';
import '@diekeure/dcr-components/dcr-dialog.js';
import '@diekeure/dcr-components/dcr-divider.js';
import '@diekeure/dcr-components/dcr-filled-button.js';
import '@diekeure/dcr-components/dcr-icon.js';
import '@diekeure/dcr-components/dcr-inline-button.js';
import '@diekeure/dcr-components/dcr-list-item.js';
import '@diekeure/dcr-components/dcr-list.js';
import '@diekeure/dcr-components/dcr-menu-item.js';
import '@diekeure/dcr-components/dcr-menu.js';
import '@diekeure/dcr-components/dcr-outline-button.js';
import '@diekeure/dcr-components/dcr-select.js';
import '@diekeure/dcr-components/dcr-text-field.js';
import { GlobalAssigneeFilterStore } from './global-assignee-filter.store';

@Component({
  standalone: false,
  selector: 'campus-global-assignee-filter',
  templateUrl: './global-assignee-filter.component.html',
  styleUrl: './global-assignee-filter.component.scss',
})
export class GlobalAssigneeFilterComponent implements OnInit {
  readonly store = inject(GlobalAssigneeFilterStore);

  public studentAmount = signal(0);

  ngOnInit(): void {
    this.studentAmount.set(Object.keys(this.store.selectedStudentIds()).length);
  }

  onSelectionChange(event: Event) {
    const target = event.target as HTMLSelectElement & { value: string[] | string };

    let selectedValues: string[] = [];
    if (Array.isArray(target.value)) {
      selectedValues = target.value;
    } else if (typeof target.value === 'string') {
      selectedValues = target.value.split(',');
    } else if (target.value) {
      selectedValues = [String(target.value)];
    }

    if (selectedValues.length === 0) {
      this.store.clearSelections();
      this.studentAmount.set(0);
      return;
    }

    const classGroupSelections: Record<string, boolean> = {};
    this.store.classGroups().forEach((cg) => {
      classGroupSelections[cg.id] = selectedValues.includes('c_' + cg.id);
    });

    const groupSelections: Record<string, boolean> = {};
    this.store.groups().forEach((g) => {
      groupSelections[g.id] = selectedValues.includes('g_' + g.id);
    });

    this.store.updateSelections(classGroupSelections, groupSelections);
  }

  onOpenStudentDialog() {
    this.store.openStudentDialog();
  }

  onCloseStudentDialog() {
    this.store.closeStudentDialog();

    const selectedStudents = this.store.selectedStudentIds();
    this.studentAmount.set(Object.values(selectedStudents).filter((isSelected) => isSelected).length);
  }

  onSearchTermUpdated(value: string) {
    this.store.setSearchTerm(value);
  }

  onStudentToggle(studentId: number, checked: boolean) {
    this.store.toggleStudent(studentId, checked);
  }
}
